import Vue from 'vue'
import Buefy from 'buefy'

Vue.use(Buefy, {
  "css": false,
  "materialDesignIcons": false,
  "materialDesignIconsHRef": null,
  "async": true
})